import * as types from "../../ActionType";

const initState = {
    deliveries: [],
    loadingDeliveries: true
}

const DeliveryReducer = (state = initState, action) => {
    switch (action.type) {
        case types.ADD_DELIVERY:
            return { ...state, loadingDeliveries: true }
        case types.GET_DELIVERIES:
            return { ...state, deliveries: action.payload, loadingDeliveries: false }
        case types.DELETE_DELIVERY:
            return { ...state}
        case types.EDIT_DELIVERY:
            return { ...state, loadingDeliveries: true }
        default:
            return state;
    }
};

export default DeliveryReducer;


